import Colors from "../../../theme/colors";

export const style = {
  container: {
    borderRadius: "12px",
    minHeight: "570px",
    background: "#FFFFFF",
  },
  inforTitle: {
    color: "#8C8C8C",
    fontSize: "20px",
  },
  flexContainer: {
    display: "flex",
  },
  keyStyle: {
    color: "#5E5E5E",
    fontSize: "14px",
  },
  valueStyle: {
    color: "#183053",
    fontSize: "16px",
  },
  buttonStyles: {
    backgroundColor: "#043D90",
    borderRadius: "8px",
    padding: "12px 28px",
  },
  titleStyles: {
    color: "#5E5E5E",
    fontSize: "14px",
    marginTop: "8px",
    marginBottom: "8px",
    fontWeight: "600",
    width: "150px",
    marginRight: "47px",
  },
  memberIdstyles: {
    color: "#183053",
    fontWeight: "500",
  },
  rowStyles: {
    color: "#183053",
    textTransform: "capitalize",
    fontWeight: "500",
    fontSize: "16px",
    padding: "12px",
  },
  titleContainer: {
    px: "12px",
    pt: "12px",
    pb: "16px",
    color: "#8C8C8C",
    backgroundColor: "#FFF",
    display: "flex",
    justifyContent: "space-between",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 0 0.6rem 0",
  },
  title: {
    color: "#8C8C8C",
    paddingLeft: "20px",
    fontSize: "1.2rem",
    fontWeight: 500,
    marginBottom: "1rem",
    verticalAlign: "middle",
  },
  SearchInput: {
    borderRadius: "8px",
    padding: "10px 5px",
    outline: "none",
    width: "270px",
    marginRight: "10px",
  },
  pagination: {
    display: "flex",
    justifyContent: "center",
    margin: "20px 0",
  },
  search: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
  },
  searchInput: {
    width: "40%",
    borderRadius: "0.5rem",
  },
  tableContainer: {
    backgroundColor: Colors.white,
    overflowX: "scroll",
  },
  tableTitle: {
    color: "#8C8C8C",
    fontSize: "1.2rem",
    fontWeight: 500,
    marginBottom: "1rem",
  },
  tableHeading: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "0.5rem",
    color: "#8C8C8C",
    whiteSpace: "nowrap",
  },
  tableInfo: {
    color: "rgba(0, 0, 0, 0.87)",
    alignItems: "flex-end",
  },
  tableRow: {
    backgroundColor: "#FFFFFF",
    border: "1px solid red",
    color: "#183053",
    textAlign: "left",
  },
  rowStyleId: {
    color: "#043D90",
    fontWeight: 500,
    textAlign: "left",
  },
  rowStyle: {
    color: "#183053",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "left",
  },
  ActionBtnContainer: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "12px",
  },
  actionBtn: {
    border: "1px solid #043D90",
    padding: "4px 16px",
    borderRadius: "8px",
    color: "#043D90",
    fontSize: "10px",
    fontWeight: "500",
    cursor: "pointer",
    textAlign: "center",
  },
  icon: {
    cursor: "pointer",
  },
  flexC: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: "20px",
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 400,
  },
  noDataMsg: {
    color: "#515772",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
};

export const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  mini: {
    maxWidth: "5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};
